import { render, staticRenderFns } from "./UserDataTable.vue?vue&type=template&id=507f06ce&scoped=true"
import script from "./UserDataTable.vue?vue&type=script&lang=js"
export * from "./UserDataTable.vue?vue&type=script&lang=js"
import style0 from "./UserDataTable.vue?vue&type=style&index=0&id=507f06ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f06ce",
  null
  
)

export default component.exports